import DataAnnotationPage from './DataAnnotationPage';

export default DataAnnotationPage;
